import { btnHtml, ribbonHtml } from "../kit";
import { confirmPurchase } from "../hub/purchaseFx";
import { SHOP_SKIN } from "../shopSkin";

/**
 * The one item popup of the Shop and the Store (owner 2026-10-24): a tap on any item tile or pack opens it — what it
 * is (itemCard.ts) over the price and BUY, the same parchment dialog as every purchase confirm (hub/purchaseFx.ts
 * confirmPurchase), so the popup is the confirm: one tap to look, one to buy. An item that can't be bought now (sold
 * out, locked) still opens, with the reason on a stamp where BUY would be. Presentation only: the caller buys.
 */

export interface ItemPopup {
  /** The ribbon (the shop's or the item's name). */
  readonly title: string;
  /** itemCardHtml / packCardHtml markup. */
  readonly body: string;
  /** The price as the button shows it (currency icon markup included), or a store's "$4.99". */
  readonly price: string;
  /** The button's word: BUY, TAKE (free), CHOOSE (a pick to make first). */
  readonly confirm?: string;
  /** Why it can't be bought right now ("Sold out", "VIP 4"): no BUY, the reason on a stamp. */
  readonly blocked?: string;
  readonly className?: string;
}

/** Opens the popup; resolves true on BUY (never for a blocked item), false on CANCEL, CLOSE or the scrim. */
export function openItemPopup(parent: HTMLElement, p: ItemPopup): Promise<boolean> {
  const cls = `sconfirm sitem ${p.className ?? ""}`.trim();
  if (!p.blocked) return confirmPurchase(parent, { shop: true, title: p.title, currency: null, price: p.price, confirm: p.confirm ?? "BUY", className: cls, body: p.body });
  return new Promise((resolve) => {
    const scrim = document.createElement("div");
    scrim.className = `scrim econconfirm ${SHOP_SKIN}`;
    scrim.innerHTML = `<div class="panel dialog econdlg ${cls}">${ribbonHtml(p.title, "", "dtitle disp")}<div class="ebody">${p.body}</div>
      <div class="row two">${btnHtml("CLOSE", "dark", { className: "cancel disp" })}<span class="k-stamp sstamp">${p.blocked}</span></div></div>`;
    const done = (): void => { scrim.remove(); resolve(false); };
    scrim.querySelector<HTMLButtonElement>(".cancel")!.onclick = done;
    scrim.onclick = (e) => { if (e.target === scrim) done(); };
    parent.append(scrim);
  });
}
